interface props {
  labelText: string;
  subheading: string;
}
const FormHeader = ({ labelText, subheading }: props) => {
  return (
    <div className="mb-3 w-full">
      <h4 className="w-full sm:text-xl md:text-2xl text-violet-500 font-semibold">
        {labelText}
      </h4>
      <p className="text-slate-500 text-sm mt-1">{subheading}</p>
    </div>
  );
};

export default FormHeader;
